import { Modal, Button } from "react-bootstrap";

const DeliveryPartnerTermsModal = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Flavchap.com - Delivery Partner Terms & Conditions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p><strong>Last Updated: </strong>{process.env.REACT_APP_DELIVERY_TERMS_UPDATE_DATE}</p>
        <h5>Hello Partner!</h5>
        <p>
          Welcome to <strong>flavchap.com</strong> (“flavchap”, “we”, “us”, “our”). These Delivery Partner Terms and Conditions (“Terms”) govern your engagement as a delivery associate for our food retail and delivery services. By registering or accepting delivery assignments through Flavchap, you agree to comply with these Terms. Please read them carefully before proceeding.
        </p>

        <h6>1. Engagement Overview</h6>
        <p>
          As a Delivery Partner, you act as an independent service provider responsible for collecting, transporting, and delivering customer orders from Flavchap’s designated facilities or partner outlets to customers’ locations.
        </p>

        <h6>2. Eligibility</h6>
        <p>
          To become or continue as a Delivery Partner, you must:
          <ul>
            <li>Be at least 18 years of age.</li>
            <li>Possess a valid government-issued ID and delivery license (if applicable).</li>
            <li>Own or have access to a vehicle in good working condition.</li>
            <li>Comply with all applicable traffic, transport, and safety laws.</li>
          </ul>
        </p>

        <h6>3. Nature of Relationship</h6>
        <p>
          You acknowledge that:
          <ul>
            <li>
              You are an <strong>independent contractor</strong>, not an employee or agent of Flavchap.
            </li>
            <li>
              No employer-employee, partnership, or joint venture relationship exists between you and Flavchap.
            </li>
            <li>
              You are responsible for your own taxes, fuel, insurance, and vehicle maintenance costs.
            </li>
          </ul>
        </p>

        <h6>4. Partner Responsibilities</h6>
        <p>
          <ul>
            <li>
              Pick up, handle, and deliver products safely and on time to the correct customer address.
            </li>
            <li>
              Verify order accuracy and condition before pickup and obtain customer confirmation at delivery.
            </li>
            <li>
              Treat customers, food vendors, and fellow partners respectfully and maintain a professional attitude.
            </li>
            <li>
              Keep delivery bags clean, food items intact, and maintain hygienic standards throughout.
            </li>
            <li>
              Immediately report any incidents, delays, or delivery failures to the Flavchap support team.
            </li>
          </ul>
        </p>

        <h6>5. Earnings and Payments</h6>
        <p>
          <ul>
            <li>
              You will receive delivery-based compensation as per the prevailing payout structure communicated by Flavchap.
            </li>
            <li>
              Payments are calculated based on completed deliveries and may include distance-based incentives or bonuses.
            </li>
            <li>
              Any fraudulent or incomplete delivery will not be eligible for payment.
            </li>
            <li>
              Payouts will be transferred to your registered bank or UPI account as per Flavchap’s payment cycle.
            </li>
          </ul>
        </p>

        <h6>6. Conduct and Compliance</h6>
        <p>
          Delivery Partners are required to:
          <ul>
            <li>Follow traffic laws and drive safely at all times.</li>
            <li>Not consume alcohol, drugs, or intoxicants while on duty.</li>
            <li>Carry valid identification and delivery app/device at all times.</li>
            <li>
              Not misuse customer information or attempt to contact customers outside of delivery purposes.
            </li>
            <li>
              Maintain honesty and professionalism — theft, tampering, or misconduct may result in termination and legal action.
            </li>
          </ul>
        </p>

        <h6>7. Equipment and App Usage</h6>
        <p>
          <ul>
            <li>
              You are responsible for maintaining your mobile device, internet connectivity, and navigation tools required for deliveries.
            </li>
            <li>
              The Flavchap Delivery Partner Website/App (if used) must only be accessed by the registered partner.
            </li>
            <li>
              Sharing login credentials or using multiple accounts is strictly prohibited.
            </li>
          </ul>
        </p>

        <h6>8. Customer Interaction</h6>
        <p>
          <ul>
            <li>
              Be courteous and professional with all customers and vendors.
            </li>
            <li>
              Do not request tips or personal information from customers.
            </li>
            <li>
              Respect customer privacy and deliver to the specified address only.
            </li>
          </ul>
        </p>

        <h6>9. Confidentiality</h6>
        <p>
          You agree to keep confidential all non-public information regarding Flavchap, its customers, and partners. Sharing or misusing any customer or company data will result in immediate termination and possible legal action.
        </p>

        <h6>10. Suspension and Termination</h6>
        <p>
          Flavchap reserves the right to suspend or terminate your access to the platform or delivery network if:
          <ul>
            <li>You violate these Terms or any applicable laws.</li>
            <li>You engage in fraudulent, unsafe, or unprofessional behavior.</li>
            <li>Repeated customer complaints or delivery issues occur.</li>
          </ul>
        </p>

        <h6>11. Liability and Insurance</h6>
        <p>
          <ul>
            <li>
              You are solely responsible for your own safety and vehicle insurance while performing deliveries.
            </li>
            <li>
              Flavchap shall not be liable for accidents, losses, or damages arising during deliveries, except where mandated by law.
            </li>
          </ul>
        </p>

        <h6>12. Indemnification</h6>
        <p>
          You agree to indemnify and hold harmless Flavchap, its affiliates, employees, and partners from any claims, losses, or damages arising from your acts, omissions, or breach of these Terms.
        </p>

        <h6>13. Modifications</h6>
        <p>
          Flavchap reserves the right to update or modify these Terms at any time without prior notice. Continued use of the platform implies acceptance of the updated Terms.
        </p>

        <h6>14. Governing Law and Jurisdiction</h6>
        <p>
          These Terms are governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts of Hyderabad, Telangana.
        </p>

        <h6>15. Contact Us</h6>
        <p>
          For queries or concerns regarding these Terms, please contact:
          <br />📧 <strong>info@ncgglobalenterprises.com</strong>
          <br />🌐 <strong>www.flavchap.com</strong>
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeliveryPartnerTermsModal;